import React, { useState } from 'react';
import styled from 'styled-components'
import { colour_lookup } from '../../common/Colours';
import { useSelector } from 'react-redux';
import { getFilterStatus } from '../../../store/positions/filterStatusSlice';

const StyledSiteClusterMarker = styled.div`
  position: absolute;
  transform: translate(-50%, -66%);
  width: 120px;
  height: 140px;
  background: '#ddd';
  // cursor: pointer;
  pointer-events: none;
`;

const StyledTooltip = styled.div<{isVisible}>`
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  pointer-events: none;
  opacity: ${props => props.isVisible ? 1 : 0};
  transition: opacity 0.2s;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 10px;
  z-index: 1000;
  display: inline-block; /* Ensures the width adjusts to the text length */
  white-space: nowrap;  /* Prevents the text from wrapping */

`;

const StyledText = styled.text`
  fill: #555;
  font-size: 12px;
  text-anchor: middle;
`;
const StyledTextRect = styled.rect`
  fill: #FFF;
  stroke-width: 0;
  stroke: #FFF;
`;

const StyledPositionCountText = styled.text`
  fill: #FFF;
  fill: black;
  font-size: 16px;
  text-anchor: middle;
  transform: translateY(-9px)
`;

const shortenText = (text, length) => {
  return `${text.slice(0,length)}${text.length > length? '...' : ''}`;
}

export const SiteClusterMarker = ({ key, lat, lng, onClick, pointCount, displayText, label, cluster }: { key: any, lat: number; lng: number; onClick?: any; pointCount: number, displayText: boolean, label: any, cluster: any}) => {
  const [isHovered, setIsHovered] = useState(false);
  const currentStatus = useSelector(getFilterStatus);

  let siteNumber = 0;
  const clusterPositionInfo = cluster.properties.positionsInfo;
  // If there are positions within a site cluster, construct the site's number of positions variable
  if(clusterPositionInfo && clusterPositionInfo.length > 0){
    switch(currentStatus) {
      case "online":
        clusterPositionInfo.forEach((position) => {
          if(position.status.online_status != "offline" && position.status.online_status != "not_measuring"){
            siteNumber++;
          }
        })
        break;
      case "offline":
        clusterPositionInfo.forEach((position) => {
          if(position.status.online_status == "offline" || position.status.online_status == "not_measuring"){
            siteNumber++;
          }
        })
        break;
      case "all":
        clusterPositionInfo.forEach((position) => {
          siteNumber++;
        })
        break;
    } 
  }
  const positionText = siteNumber > 1? " Positions " : " Position ";

  return (
    <div style={{ position: 'relative' }}>
      <StyledSiteClusterMarker
        onMouseEnter={() => setIsHovered(true)} 
        onMouseLeave={() => setIsHovered(false)}>  
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 140' style={{pointerEvents: "none"}}>

          <filter id="shadow">
            <feDropShadow dx="0" dy="2" stdDeviation="0.9"/>
          </filter>
          <filter id="shadowSmall">
            <feDropShadow dx="0" dy="1.5" stdDeviation="0.9"/>
          </filter>

          <circle cx='60' cy='55' r='25' fill={colour_lookup('dark_blue')} style={{filter: 'url(#shadowSmall)', pointerEvents: "auto", cursor: "pointer"}} onClick={() => { onClick(cluster) }}/>
          <circle cx='60' cy='55' r='20' fill={colour_lookup('white')} style={{filter: 'url(#shadowSmall)', pointerEvents: "auto", cursor: "pointer"}} onClick={() => { onClick(cluster) }}/>
          {(pointCount &&
            <StyledPositionCountText x='60' dy='70' style={{pointerEvents: "auto", cursor: "pointer"}} onClick={() => { onClick(cluster) }}>{displayText? siteNumber : pointCount}{displayText? "P" : "S"}</StyledPositionCountText>
          )}

          {(displayText &&
          <g transform='translate(0, -18)'>
          <StyledTextRect x='5' y='105' width='110' height='20' rx='10' ry='10' style={{filter:'url(#shadowSmall)'}}/>
          <StyledText x='60' dy='120'>{shortenText(label, 15)}</StyledText>
          </g>
          )}
        </svg>
      </StyledSiteClusterMarker>
      <StyledTooltip isVisible={isHovered}>
          {displayText? siteNumber : pointCount} {displayText? positionText : " Sites "} in this cluster
        </StyledTooltip>
    </div>
  )
}
